import { ofType } from 'redux-observable';
import { catchError, map, switchMap } from 'rxjs/operators';
import { fromPromise } from 'rxjs/internal-compatibility';
import * as api from '@api/search';
import { of } from 'rxjs';
import {
  TOLLS_FETCH,
  TOLLS_FETCH_ERROR,
  TOLLS_FETCH_SUCCESS,
} from '@actions/search';

export const fetchTolls = action$ =>
  action$.pipe(
    ofType(TOLLS_FETCH),
    switchMap(action =>
      fromPromise(api.fetchTolls(action.payload)).pipe(
        map(({ data }) => {
          return { type: TOLLS_FETCH_SUCCESS, payload: data };
        }),
        catchError(err => of({ type: TOLLS_FETCH_ERROR, payload: err })),
      ),
    ),
  );
